/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAtan } from '../../factoriesAny.js';
export var atanDependencies = {
  typedDependencies,
  createAtan
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesAtan.generated.js
// module id = 523
// module chunks = 2